import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import Form from '../form/Form';

class VehicleOperations extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      ready: false,
      layout: [],
      hideSubmit: false,
    };
  }
  componentDidMount() {
    const { vin } = this.props;

    ApiService.get(`vehicle/vinlookup/${vin}`).then(response => {
      if (_.get(response, 'data.mfrindex')) {
        const mfrindex = _.get(response, 'data.mfrindex');
        ApiService.get(`vehicle/vmrs3/${vin}`, { params: { mfrindex } })
          .then(response => {
            const layout = [
              {
                name: 'vin',
                label: 'VIN',
                displayOnly: true,
                data: vin,
              },
              {
                name: 'vin_lookup',
                hidden: true,
                data: mfrindex,
              },
              {
                name: 'vmrs3',
                label: 'Select a Category',
                options: response.data,
                events: {
                  blur: {
                    update: {
                      method: {
                        name: 'getvmrs6',
                        keys: ['vin', 'vmrs3', 'vin_lookup'],
                      },
                    },
                  },
                },
              },
              {
                name: 'vmrs6',
                label: 'Select a Part',
                options: [],
                noEmptyOption: true,
                events: {
                  blur: {
                    update: {
                      method: {
                        name: 'getlabordesc',
                        keys: ['vin', 'vmrs6', 'vin_lookup'],
                      },
                    },
                  },
                },
              },
              {
                name: 'labordescmash',
                label: 'Labor Description',
                options: [],
                noEmptyOption: true,
                events: {
                  blur: {
                    update: {
                      method: {
                        name: 'getlabordetail',
                        keys: ['vin', 'vmrs6', 'vin_lookup', 'labordescmash'],
                      },
                    },
                  },
                },
              },
              {
                name: 'labordetail',
                label: 'Labor Details',
                options: [],
                events: {
                  blur: {
                    update: {
                      method: {
                        name: 'populateLaborDetails',
                        keys: ['labordetail'],
                      },
                    },
                  },
                },
              },
              {
                name: 'labormodel',
                hidden: true,
              },
              {
                name: 'laborhours',
                hidden: true,
              },
              {
                name: 'laboryear',
                hidden: true,
              },
              {
                name: 'laborverb',
                hidden: true,
              },
              {
                name: 'labordesc',
                hidden: true,
              },
              {
                name: 'labornote',
                hidden: true,
              },
              {
                name: 'partId',
                hidden: true,
              },
            ];

            this.setState({ layout, ready: true });
          })
          .catch(() => {
            const layout = [
              {
                control: 'paragraph',
                data: `VIN ${vin} is not supported`,
                name: 'error',
                style: 'banner',
              },
            ];

            this.setState({ layout, ready: true, hideSubmit: true });
          });
      } else {
        const layout = [
          {
            control: 'paragraph',
            data: `VIN ${vin} is not supported`,
            name: 'error',
            style: 'banner',
          },
        ];

        this.setState({ layout, ready: true, hideSubmit: true });
        console.error('Missing make index', response);
      }
    });
  }

  handleSubmit(payload) {
    const { rowId, dataIndex } = this.props;

    // Very SMM1 specific stuff
    const update = {
      SMM1__73: payload.laborhours,
      SMM1__70: `${payload.vmrs6}\n${payload.labordesc}\n${payload.labormodel}`,
    };

    this.props.formHandler.updateForm(update, dataIndex, rowId);
    this.props.close();
  }

  render() {
    if (!this.state.ready) {
      return <LoadingPage style={{ padding: '50px' }} />;
    }

    return (
      <div className="vehicle-operations">
        <Form
          layout={this.state.layout}
          submit={this.handleSubmit}
          submitAll
          onCancel={this.props.close}
          exportFormat="object"
          hideSubmit={this.state.hideSubmit}
        />
      </div>
    );
  }
}

VehicleOperations.propTypes = {
  vin: PropTypes.string,
  rowId: PropTypes.number,
  dataIndex: PropTypes.number,
  formHandler: PropTypes.object,
  close: PropTypes.func,
};

export default VehicleOperations;
